
export const common = {
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.edit': 'Modifier',
  'common.save': 'Enregistrer',
  'common.saving': 'Enregistrement...',
  'common.sending': 'Envoi...',
  'common.cancel': 'Annuler',
  'common.clear': 'Effacer',
  'common.showFilters': 'Afficher les filtres',
  'common.hideFilters': 'Masquer les filtres',
  'common.selectFarm': 'Sélectionner une ferme',
  'common.search': 'Rechercher',
  'common.filter': 'Filtrer',
  'common.apply': 'Appliquer',
  'common.remove': 'Supprimer',
  'common.upload': 'Télécharger',
  'common.select': 'Sélectionner',
  'common.add': 'Ajouter',
  'common.delete': 'Supprimer',
  'common.continue': 'Continuer',
  'common.goBack': 'Retour',
  'common.expired': 'Expiré',
  'common.pending': 'En attente',
  'common.completed': 'Terminé',
  'common.draft': 'Brouillon',
  'common.share': 'Partager',
  'common.copy': 'Copier',
  'common.submit': 'Soumettre',
  'common.back': 'Retour',
  'common.next': 'Suivant',
  'common.review': 'Réviser',
  'common.success': 'Succès',
  'common.error': 'Erreur',
  'common.warning': 'Avertissement',
  'common.info': 'Information',
  'common.applied': 'Appliqué',
  'common.saved': 'Enregistré',
  // Adding the missing translations
  'common.send': 'Envoyer',
  'common.landRegistryCertificate': 'Certificat du Registre Foncier',
  'common.irrigationForm': 'Formulaire d\'Irrigation',
  'common.uploadFromVault': 'Charger depuis le Coffre',
  'common.demoDisclaimer': 'Ceci est une démonstration d\'AgriTool Advisor. Pas pour les demandes réelles de subventions.',
  'common.lastUpdated': 'Dernière Mise à Jour',
  'common.openClientProfile': 'Ouvrir le Profil Client',
  'common.applyNow': 'Postuler Maintenant',
  'common.newSubsidyAvailable': 'Nouvelle Subvention Disponible',
  'common.documentsRequired': 'Documents Requis',
  'common.inReview': 'En Révision',
  'common.readyToSubmit': 'Prêt à Soumettre',
  'common.deadlineApproaching': 'Date Limite Approche',
  'common.demoLabel': 'Démo',
  'common.dashboard': 'Tableau de Bord',
  'common.plan': 'Plan',
  'common.consultantPro': 'Consultant Pro',
  'common.free': 'Gratuit',
  'common.coopEnterprise': 'Entreprise Coopérative',
  'common.documents': 'Documents',
  'common.skipToEUPortal': 'Passer au Portail UE',
  'common.addNewClientFarm': 'Ajouter une Nouvelle Ferme Client',
  'common.searchFarms': 'Rechercher des fermes...',
  'common.name': 'Nom',
  'common.region': 'Région',
  'common.status': 'Statut',
  'common.size': 'Taille',
  'common.activities': 'Activités',
  'common.software': 'Logiciel',
  'common.addNewSubsidy': 'Ajouter une Nouvelle Subvention',
  'common.noSubsidiesFound': 'Aucune Subvention Trouvée',
  'common.noSubsidiesFoundDesc': 'Aucune subvention ne correspond aux critères actuels. Essayez d\'ajuster vos filtres.',
  'common.loading': 'Chargement',
  'common.close': 'Fermer',
  'common.continueToEUPortal': 'Continuer vers le Portail UE',
  'common.generateForm': 'Générer le Formulaire',
  'common.uploadNow': 'Télécharger Maintenant',
  'common.viewDetails': 'Voir les Détails',
  // Add more missing keys
  'common.profile': 'Profil',
  'common.subsidies': 'Subventions',
  'common.applications': 'Applications',
  'common.getStarted': 'Commencer',
  'common.returnHome': 'Retour à la Page d\'Accueil',
  'common.backToDashboard': 'Retour au Tableau de Bord',
  'common.explainThis': 'Expliquer Ceci',
  'common.attach': 'Joindre',
  'common.useToPrefillProfile': 'Utiliser pour Compléter le Profil',
  'common.prefillNow': 'Oui, Compléter Maintenant',
  'common.noThanks': 'Non, Merci',
  'common.dontAskAgain': 'Ne Plus Demander',
  'common.usePrefillPrompt': 'Souhaitez-vous utiliser les informations de ce document pour compléter votre profil de ferme?',
  'common.extractionCompleted': 'Analyse du document terminée',
  'common.extractionAvailable': 'Pré-remplissage intelligent disponible',
  'common.confidence': 'Confiance',
  'common.prefillApplied': 'Formulaire pré-rempli avec les données extraites',
  'common.extractionProcessing': 'Traitement du document...',
  'common.extractionFailed': 'Analyse du document échouée',
  'common.extracted': 'Extrait',
  'common.readyToExtract': 'Prêt pour l\'extraction',
  'common.documentsUploaded': 'Documents téléchargés avec succès',
  'common.extractAndPrefill': 'Extraire et Pré-remplir',
  'common.reExtract': 'Re-extraire',
  'common.extracting': 'Extraction...',
  'common.extractionSuccess': 'Données extraites avec succès de {fileName}',
  'common.extractionError': 'Échec de l\'extraction des données du document',
  'common.login': 'Se connecter',
  'common.signUp': 'Inscription',
  'common.startFreeTrial': 'Commencer',
  'common.administrator': 'Administrateur',
  'common.businessUser': 'Utilisateur professionnel',
  'common.consultant': 'Consultant',
  'common.enterprise': 'Entreprise',
  'common.adminOnly': 'Admin uniquement',
  'common.devTools': 'Outils développeur', 
  'common.requires': 'Nécessite',
  'common.role': 'rôle',
  'common.comingSoon': 'Bientôt disponible',
  'common.yourProfiles': 'Clients Actifs',
  'common.yourSuspendedProfiles': 'Clients Inactifs',
  'common.findOpportunities': 'Trouver des opportunités',
  'common.allTypes': 'Tous types',
  'common.individual': 'Particulier',
  'common.business': 'Entreprise',
  'common.nonprofit': 'Association',
  'common.municipality': 'Collectivité',
  'common.profileCompletion': 'Profil complété',
  'common.updated': 'Mis à jour',
  'common.availableSubsidies': 'Subventions disponibles',
  'common.urgent': 'Urgent',
  'common.viewProfile': 'Voir le profil',
  'common.completeProfile': 'Compléter le profil',
  'common.createNewProfile': 'Créer un nouveau profil client',
  'common.nextSteps': 'Prochaines étapes',
  'common.highPriority': 'Haute priorité',
  'common.new': 'Nouveau',
  'common.open': 'Ouvert',
  // Legacy migration keys
  'common.tryAgain': 'Réessayer',
  'common.backToSearch': 'Retour à la recherche',
  'common.favorite': 'Favori',
  'common.contactSupport': 'Contacter le support',
  'common.pricing': 'Tarifs',
  'common.moreInfo': 'Plus d\'informations',
  'common.features': 'Fonctionnalités',
  'common.menu': 'Menu',
  // AI Assistant page
  'common.aiAssistantTitle': 'Assistant IA',
  'common.aiAssistantDescription': 'Posez vos questions sur les subventions, l\'éligibilité et les processus de candidature. Notre assistant IA est là pour vous aider.',
  'common.instantAnswers': 'Réponses instantanées',
  'common.instantAnswersDesc': 'Obtenez des réponses rapides à vos questions sur les subventions',
  'common.personalized': 'Personnalisé',
  'common.personalizedDesc': 'Des conseils adaptés à votre situation et vos besoins',
  'common.available247': 'Disponible 24/7',
  'common.available247Desc': 'Assistance disponible à tout moment, jour et nuit',

  // Chat component messages
  'common.chatTitle': 'Assistant Subventions',
  'common.chatInitialMessage': 'Bonjour ! Je peux vous aider à comprendre les exigences des subventions et les processus de candidature. Que souhaitez-vous savoir ?',
  'common.chatPlaceholderResponse': 'Ceci est une réponse temporaire. Dans une implémentation réelle, cela se connecterait à un service IA pour fournir des conseils détaillés sur les subventions.',
  'common.chatInputPlaceholder': 'Posez une question sur les subventions...',

  // Conversation history
  'common.conversationHistory': 'Historique des Conversations',
  'common.hideHistory': 'Masquer l\'Historique',
  'common.showRecent': 'Récentes',
  'common.showArchived': 'Archivées',
  'common.noConversations': 'Aucune conversation pour le moment',
  'common.noArchivedConversations': 'Aucune conversation archivée',
  'common.messages': 'messages',
  'common.archive': 'Archiver',
  'common.unarchive': 'Désarchiver',
  'common.confirmDelete': 'Êtes-vous sûr de vouloir supprimer définitivement cet élément ?',
  'common.newConversation': 'Nouvelle Conversation',
  'common.saveConversation': 'Enregistrer la Conversation',
  'common.conversationSaved': 'Conversation Enregistrée',
  'common.conversationSavedSuccessfully': 'Votre conversation a été enregistrée avec succès',
  'common.noMessagesToSave': 'Aucun message à enregistrer',
  'common.startConversationFirst': 'Commencez une conversation avant de l\'enregistrer',
  'common.failedToSaveConversation': 'Échec de l\'enregistrement de la conversation',
  'common.conversationArchivedAndNewStarted': 'La conversation précédente a été archivée. Une nouvelle conversation a commencé.',
  'common.failedToArchiveConversation': 'Échec de l\'archivage de la conversation',

  // Navigation & Sidebar
  'common.newProfile': 'Nouveau Client',
  'common.favorites': 'Favoris',
  'common.categories': 'Catégories',
  'common.help': 'Aide',
  'common.admin': 'Admin',
  'common.needHelp': 'Support',

  // Actions
  'common.confirm': 'Confirmer',
  'common.view': 'Voir',
  'common.download': 'Télécharger',
  'common.modify': 'Modifier',

  // Status
  'common.closed': 'Fermé',

  // Colors
  'common.purple': 'Violet',
  'common.blue': 'Bleu',
  'common.green': 'Vert',
  'common.amber': 'Ambre',
  'common.gray': 'Gris',
  'common.red': 'Rouge',
  'common.pink': 'Rose',
  'common.teal': 'Turquoise',

  // Placeholders
  'common.searchProfile': 'Rechercher un profil...',
  'common.searchArchivedClient': 'Rechercher un client archivé...',
  'common.searchByCodeOrActivity': 'Rechercher par code NAF ou par activité (ex: conseil, commerce, fabrication...)...',
  'common.searchByTitleOrDescription': 'Rechercher par titre, description ou agence...',
  'common.searchByNameOrNumber': 'Rechercher par nom ou numéro (ex: commerce, 47, restauration...)',
  'common.searchTickets': 'Rechercher des tickets...',
  'common.searchErrors': 'Rechercher des erreurs par message ou type...',
  'common.addDocument': 'Ajouter un document...',
  'common.addNotes': 'Ajouter des notes...',
  'common.additionalInfo': 'Informations supplémentaires sur ce document...',
  'common.addReviewNotes': 'Ajouter vos notes de révision...',
  'common.addComment': 'Ajouter un commentaire...',

  // Aria labels
  'common.closeHelp': 'Fermer l\'aide',
  'common.openHelp': 'Ouvrir l\'aide',
  'common.closeAlerts': 'Fermer les alertes',
  'common.viewDocument': 'Voir le document {name}',
  'common.viewDetailsFor': 'Voir les détails pour {name}',
  'common.addNewFarm': 'Ajouter une nouvelle ferme',
  'common.searchYourFarms': 'Rechercher vos fermes',

  // AddFarm Modal
  'addFarm.createComprehensiveProfile': 'Créer un profil d\'entreprise complet avec toutes les informations requises',
  'addFarm.fillCompleteFarmProfile': 'Remplissez le formulaire de profil d\'entreprise complet pour ajouter un nouveau client à votre portefeuille',
  'addFarm.startProfileCreation': 'Commencer la création du profil',

  // Sorting & Filtering
  'common.sortRecent': 'Plus récent',
  'common.sortName': 'Nom (A-Z)',
  'common.sortCompletion': 'Complétude',
  'common.allCategories': 'Toutes les catégories',
  'common.editCategories': 'Modifier les catégories',
  'common.creationInProgress': 'Création en cours...',
  'common.calculationFailed': 'Échec du calcul',

  // Loading status messages (V5 matching)
  'common.loadingStatus.analyzingProfile': 'Analyse du profil...',
  'common.loadingStatus.searchingSubsidies': 'Recherche de subventions...',
  'common.loadingStatus.checkingEligibility': 'Vérification de l\'éligibilité...',
  'common.loadingStatus.evaluatingMatches': 'Évaluation des correspondances...',
  'common.loadingStatus.aiAnalysis': 'Analyse par intelligence artificielle...',
  'common.loadingStatus.identifyingOpportunities': 'Identification des opportunités...',
  'common.loadingStatus.calculatingScores': 'Calcul des scores...',
  'common.loadingStatus.selectingBestSubsidies': 'Sélection des meilleures aides...',
  'common.loadingStatus.comparingWithProfile': 'Comparaison avec le profil...',
  'common.loadingStatus.analyzingCriteria': 'Analyse des critères...',

  // Profile Dialog
  'common.profilesAvailable': '{count} profil disponible',
  'common.profilesAvailable_plural': '{count} profils disponibles',
  'common.profilesSuspended': '{count} profil suspendu',
  'common.profilesSuspended_plural': '{count} profils suspendus',
  'common.noProfilesYet': 'Aucun profil créé pour le moment',
  'common.noSuspendedProfiles': 'Aucun profil suspendu',
  'common.noProfileFound': 'Aucun profil trouvé',
  'common.noProfiles': 'Aucun profil',
  'common.tryAnotherSearch': 'Essayez une autre recherche',
  'common.createFirstProfile': 'Créez votre premier profil pour commencer',
  'common.loadingMoreProfiles': 'Chargement de plus de profils...',
  'common.loadingMoreSubsidies': 'Chargement de plus de subventions...',
  'common.scrollToLoadMore': 'Faites défiler pour charger plus de subventions',
  'common.noProfilesInCategory': 'Aucun profil dans {category}',
  'common.noCategoryAssigned': 'Aucun client n\'a été assigné à cette catégorie pour le moment',
  'common.createYourFirstProfile': 'Créer votre premier profil',
  'common.firstProfileDescription': 'Créez votre premier profil client pour commencer à découvrir des subventions adaptées',

  // Archived Clients
  'common.loadingArchivedProfiles': 'Chargement des profils archivés...',
  'common.archivedClients': 'Clients archivés',
  'common.clientArchived': '{count} client archivé',
  'common.clientArchived_plural': '{count} clients archivés',
  'common.refresh': 'Actualiser',
  'common.archivedClientsInfo': 'Les clients archivés ne comptent pas dans votre facturation. Vous pouvez les réactiver à tout moment.',
  'common.noResults': 'Aucun résultat',
  'common.noArchivedClients': 'Aucun client archivé',
  'common.archivedClientsWillAppearHere': 'Les clients archivés apparaîtront ici',
  'common.client': 'Client',
  'common.type': 'Type',
  'common.reason': 'Raison',
  'common.archived': 'Archivé',
  'common.actions': 'Actions',
  'common.profileComplete': 'Profil {percent}% complet',
  'common.notSpecified': 'Non spécifié',
  'common.showing': 'Affichage de {filtered} sur {total} client',
  'common.showing_plural': 'Affichage de {filtered} sur {total} clients',
  'common.reactivateTip': '💡 Astuce : Réactivez un client pour qu\'il compte à nouveau dans votre facturation',
  'common.selected': 'Sélectionné',

  // Applicant Type Descriptions
  'common.businessDescription': 'Sociétés, startups, PME, grandes entreprises',
  'common.nonprofitDescription': 'Structures publiques, collectivités territoriales et associations',
  'common.municipalityDescription': 'Collectivités territoriales et projets d\'intérêt général',
  'common.individualDescription': 'Financement personnel, freelances, entrepreneurs individuels',
  'common.creationTitle': 'Création et Reprise',
  'common.creationDescription': 'Projets de création ou reprise d\'entreprise',

  // Applicant Type Examples
  'common.innovationGrants': 'Subventions innovation',
  'common.exportAid': 'Aide à l\'export',
  'common.rdFunding': 'Financement R&D',
  'common.digitalTransformation': 'Transformation numérique',
  'common.socialPrograms': 'Programmes sociaux',
  'common.communityProjects': 'Projets communautaires',
  'common.culturalInitiatives': 'Initiatives culturelles',
  'common.environmentalActions': 'Actions environnementales',
  'common.infrastructure': 'Infrastructure',
  'common.urbanDevelopment': 'Développement urbain',
  'common.publicServices': 'Services publics',
  'common.smartCityProjects': 'Projets smart city',
  'common.personalGrants': 'Bourses personnelles',
  'common.trainingAid': 'Aide à la formation',
  'common.housingAid': 'Aide au logement',
  'common.trainingPrograms': 'Programmes de formation',
  'common.creationAid': 'Aide à la création',
  'common.startupSupport': 'Accompagnement startup',
  'common.launchFunding': 'Financement lancement',
  'common.incubation': 'Incubation',

  // Error Boundary
  'error.title': 'Une erreur est survenue',
  'error.description': 'Une erreur inattendue s\'est produite. Nous avons été notifiés et travaillons sur une correction.',
  'error.details': 'Détails de l\'erreur',
  'error.code': 'Code',
  'error.message': 'Message',
  'error.technicalDetails': 'Détails Techniques',
  'error.tryAgain': 'Réessayer',
  'error.reloadPage': 'Recharger la Page',
  'error.goHome': 'Retour à l\'Accueil',
  'error.reportBug': 'Signaler un Bug',
  'error.supportMessage': 'Si ce problème persiste, veuillez contacter le support à',
  'error.errorId': 'ID d\'erreur',
  'error.loadingPage': 'Erreur de Chargement de la Page',
  'error.goBack': 'Retour',
  'error.bugReportSubject': 'Rapport de Bug',
  'error.bugReportBody': 'Erreur: {message}\nCode: {code}\nHorodatage: {timestamp}\n\nPile de Composants:\n{stack}',

  // Workspace
  'workspace.selectSubsidiesToTransmit': 'Sélectionnez les financements à transmettre',
  'workspace.generateDocument': 'Générer document',

  // AI Strategic Report
  'common.matches': 'correspondances',
  'common.generating': 'Génération...',
  'strategicReport.title': 'Rapport Stratégique IA',
  'strategicReport.description': 'Obtenez une analyse personnalisée de vos meilleures options de financement, combinaisons optimales et conseils de timing.',
  'strategicReport.generate': 'Générer',
  'strategicReport.notEnoughMatches': 'Complétez votre profil pour obtenir au moins 3 correspondances et accéder à un rapport stratégique personnalisé.',
  'strategicReport.error': 'Erreur lors de la génération du rapport',
  'strategicReport.potentialFunding': 'Financement potentiel',
  'strategicReport.topRecommendations': 'Recommandations prioritaires',
  'strategicReport.combinationStrategies': 'Stratégies de cumul',
  'strategicReport.urgentDeadlines': 'Échéances urgentes',
  'strategicReport.nextSteps': 'Prochaines étapes',
  'strategicReport.confidence': 'Niveau de confiance',

  // Deadline Explanation
  'deadline.explainButton': 'Comprendre',
  'deadline.whyImportant': 'Pourquoi important?',
  'deadline.modalTitle': 'Analyse du Délai',
  'deadline.dueDate': 'Date limite',
  'deadline.analyzing': 'Analyse en cours...',
  'deadline.error': 'Erreur lors de l\'analyse',
  'deadline.urgencyLevel': 'Niveau d\'urgence',
  'deadline.daysRemaining': 'jours restants',
  'deadline.strategicContext': 'Contexte stratégique',
  'deadline.bestTime': 'Meilleur moment pour candidater',
  'deadline.actionItems': 'Actions recommandées',
  'deadline.urgency.critical': 'Critique - Action immédiate requise',
  'deadline.urgency.high': 'Haute - Agir rapidement',
  'deadline.urgency.medium': 'Modérée - Planifier bientôt',
  'deadline.urgency.low': 'Faible - Temps disponible',

  // Eligibility Q&A
  'eligibility.button': 'Questions?',
  'eligibility.askQuestion': 'Poser une question',
  'eligibility.cardTitle': 'Questions d\'éligibilité?',
  'eligibility.cardDesc': 'Posez vos questions sur cette aide et obtenez des réponses personnalisées',
  'eligibility.modalTitle': 'Questions d\'Éligibilité',
  'eligibility.suggestedQuestions': 'Questions fréquentes',
  'eligibility.inputPlaceholder': 'Posez votre question...',
  'eligibility.analyzing': 'Analyse en cours...',
  'eligibility.error': 'Erreur lors de l\'analyse',
  'eligibility.result.eligible': 'Probablement éligible',
  'eligibility.result.notEligible': 'Probablement non éligible',
  'eligibility.result.uncertain': 'Incertain - plus d\'infos nécessaires',
  'eligibility.missingInfo': 'Informations manquantes:',
  'eligibility.suggestions': 'Conseils:',
  'eligibility.suggested.size': 'Mon entreprise de 5 employés est-elle éligible?',
  'eligibility.suggested.sector': 'Cette aide est-elle accessible aux startups tech?',
  'eligibility.suggested.cumul': 'Puis-je cumuler cette aide avec d\'autres subventions?',
  'eligibility.suggested.timing': 'Dois-je avoir déjà commencé mon projet?',

  // Saved Searches
  'savedSearches.saveDialogTitle': 'Sauvegarder la recherche',
  'savedSearches.saveDialogDescription': 'Donnez un nom à cette recherche pour la retrouver facilement.',
  'savedSearches.nameLabel': 'Nom',
  'savedSearches.defaultName': 'Ma recherche',
  'savedSearches.query': 'Recherche',
  'savedSearches.filters': 'Filtres',
  'savedSearches.activeFilters': 'filtre(s) actif(s)',
  'savedSearches.noFilters': 'Aucun filtre ou recherche actif',
  'savedSearches.errorNameRequired': 'Veuillez entrer un nom',
  'savedSearches.errorNameTooLong': 'Le nom ne peut pas dépasser 100 caractères',
  'savedSearches.saveSuccess': 'Recherche sauvegardée',
  'savedSearches.saveError': 'Erreur lors de la sauvegarde',
} as const;
